import { Done, FilterAltOutlined } from '@mui/icons-material';
import { Button, CircularProgress } from '@mui/material';
import { t } from 'i18next';
import { useState } from 'react';
import { ProjectException } from '../../../project-exceptions/models/ProjectException';
import { PATHS } from '../../../routing/routes';
import { UrlHelper } from '../../utils/UrlHelper';
import { StackFrame } from '../models/StackFrame';

type Props = {
  frame: StackFrame;
  tabIndex: 0 | -1;
  onCreate: (term: string) => Promise<ProjectException | null>;
};

export const CreateExceptionButton = ({ frame, tabIndex, onCreate }: Props) => {
  const [creatingException, setCreatingException] = useState<boolean>(false);
  const [exception, setException] = useState<ProjectException | null>(null);

  const term = frame.getFullMethodName();

  const handleCreateException = async () => {
    if (!term) return;

    setCreatingException(true);
    const exception = await onCreate(term);
    setCreatingException(false);
    setException(exception);
  };

  if (exception) {
    return (
      <Button
        tabIndex={tabIndex}
        variant="outlined"
        color="success"
        href={UrlHelper.generatePath(PATHS.PROJECT_FILTERS, { projectId: exception.getProjectId().toString() })}
        startIcon={<Done />}
      >
        {t('viewException')}
      </Button>
    );
  }
  return (
    <Button
      tabIndex={tabIndex}
      variant="outlined"
      disabled={!term || creatingException}
      startIcon={creatingException ? <CircularProgress size={20} sx={{ p: '1px' }} /> : <FilterAltOutlined />}
      sx={{ display: 'flex !important' }}
      onClick={handleCreateException}
    >
      {t('addException')}
    </Button>
  );
};
